<div class="container chose-plan">

  <div class="container-body">

    <div class="choose-plan-page-header">
      <div class="chose-plan-page-title-position">
        <span class="chose-plan-page-title">{{ 'TRANSLATE.CHOOSE.PLAN' | translate }}</span>
      </div>
    </div>

    <div
      class="grid chose-plan-hero-block chose-plan-layout-panel chose-plan-layout-panel-hero chose-plan-animate-in chose-plan-animate-delay-1">
      <div class="col-12 chose-plan-hero-head">
        <i class="pi pi-check chose-plan-hero-head-icon" aria-hidden="true"></i>
        <span class="chose-plan-hero-head-title">{{ 'TRANSLATE.BENEFITS.INCLUDED' | translate }}</span>
      </div>

      <div class="col-12 chose-plan-hero-row">
        <div class="chose-plan-hero-item">
          <span class="chose-plan-hero-icon-wrap" aria-hidden="true">
            <i class="pi pi-shield chose-plan-hero-benefit-icon"></i>
          </span>
          <div class="chose-plan-hero-text">
            <div class="chose-plan-span_start">
              <span class="chose-plan-span_bold">{{ choosePlan.factoryTimeLimit }} {{
                'TRANSLATE.MONTHS.WARRANTY' |
                translate }}</span>
            </div>
            <div class="chose-plan-hero-item-subtitle">
              @if (choosePlan.factoryDistanceLimit === 999999) {
              <span>{{ 'TRANSLATE.UNLIMITED.KM' | translate }}</span>
              }
              @if (choosePlan.factoryDistanceLimit !== 999999) {
              <span>{{ choosePlan.factoryDistanceLimit }} {{ 'TRANSLATE.WARRANTY.KM' | translate }}</span>
              }
            </div>
          </div>
        </div>

        <div class="chose-plan-hero-item">
          <span class="chose-plan-hero-icon-wrap" aria-hidden="true">
            <i class="pi pi-clock chose-plan-hero-benefit-icon"></i>
          </span>
          <div class="chose-plan-hero-text">
            <div class="chose-plan-span_start">
              <span class="chose-plan-span_bold">{{ 'TRANSLATE.FORD.ASSISTANCE' | translate }}</span>
            </div>
            @if (systemCountry !== 'ARG' ) {
            <div class="chose-plan-hero-item-subtitle">
              <span>{{ 'TRANSLATE.YEAR.ASSISTANCE.HOURS' | translate }}</span>
            </div>
            }
          </div>
        </div>
      </div>

      <div class="col-12 chose-plan-hero-notes">
        <span class="chose-plan-hero-note-item">• {{ 'TRANSLATE.MAX.MILEAGE.PLAN.KM' | translate }}</span>
        <span class="chose-plan-hero-note-item">• {{ 'TRANSLATE.TOTAL.VEHICLE.MILEAGE' | translate }}</span>
      </div>
    </div>

    <div
      class="grid chose-plan-total-list chose-plan-layout-panel chose-plan-layout-panel-options chose-plan-animate-in chose-plan-animate-delay-2">
      <div class="col-12 chose-plan-apply_margin_bottom chose-plan-cards-wrap">
        <div class="chose-plan-cards-row">
          <div class="chose-plan-card-col">
            <button type="button" class="chose-plan-button-plan"
              [disabled]="selectingExtendedWarranty || isPlansLoading"
              [ngClass]="{ 'chose-plan-button-plan-selected': planFordProtect?.planSelectedEnum === warranty }"
              (click)="onClickPlan(warranty)">
              <div class="chose-plan-button-plan-text">
                <i class="fas fa-award chose-plan-icon"></i>
                <span class="chose-plan-button-plan-label">{{ 'TRANSLATE.WARRANTY.EXTENSION' | translate }}</span>
              </div>
            </button>
            <div class="grid chose-plan-price-row">
              <div class="col-12 chose-plan-span-value">
                @if (choosePlanBuyng.extension?.planName) {
                <span>
                  {{ choosePlanBuyng.extension.itemPrice
                  | currency : getCurrencyCodeByCountry() : getCurrencyDisplayByCountry() : '1.2-2' : getLocaleByCountry() }}
                </span>
                }
              </div>
            </div>
          </div>

          <div class="chose-plan-card-col">
            <button type="button" class="chose-plan-button-plan" [disabled]="selectingPreOwnedReviews || isPlansLoading"
              [ngClass]="{ 'chose-plan-button-plan-selected': planFordProtect?.planSelectedEnum === tool }"
              (click)="onClickPlan(tool)">
              <div class="chose-plan-button-plan-text">
                <i class="fas fa-tools chose-plan-icon"></i>
                <span class="chose-plan-button-plan-label">{{ 'TRANSLATE.MAINTENANCE.PRE.ACQUIRED' | translate }}</span>
              </div>
            </button>
            <div class="grid chose-plan-price-row">
              <div class="col-12 chose-plan-span-value">
                @if (choosePlanBuyng.maintenance?.planName) {
                <span>
                  {{ choosePlanBuyng.maintenance.itemPrice
                  | currency : getCurrencyCodeByCountry() : getCurrencyDisplayByCountry() : '1.2-2' : getLocaleByCountry() }}
                </span>
                }
              </div>
            </div>
          </div>

          <div class="chose-plan-card-col">
            <button type="button" class="chose-plan-button-plan"
              [disabled]="selectingOverhaulsWearParts || isPlansLoading"
              [ngClass]="{ 'chose-plan-button-plan-selected': planFordProtect?.planSelectedEnum === toolPiece }"
              (click)="onClickPlan(toolPiece)">
              <div class="chose-plan-button-plan-text">
                <i class="fas fa-cogs chose-plan-icon"></i>
                <span class="chose-plan-button-plan-label">{{ 'TRANSLATE.REVISIONS.WEAR.PART' | translate }}</span>
              </div>
            </button>
            <div class="grid chose-plan-price-row">
              <div class="col-12 chose-plan-span-value">
                @if (choosePlanBuyng.part?.planName) {
                <span>
                  {{ choosePlanBuyng.part.itemPrice | currency : getCurrencyCodeByCountry() : getCurrencyDisplayByCountry() : '1.2-2' :
                  getLocaleByCountry() }}
                </span>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="grid table-position chose-plan-layout-panel chose-plan-layout-panel-table chose-plan-animate-in chose-plan-animate-delay-3">
      @if (isPlansLoading) {
      <div class="col-12 chose-plan-loading-status" aria-live="polite">
        <div class="chose-plan-loading-panel">
          <div class="chose-plan-loading-head">
            <span class="chose-plan-loading-icon" aria-hidden="true">
              <i class="pi pi-spin pi-spinner"></i>
            </span>
            <div class="chose-plan-loading-copy">
              <span class="chose-plan-loading-title">{{ 'TRANSLATE.CHOOSE.PLAN.LOADING.TITLE' | translate }}</span>
              <span class="chose-plan-loading-subtitle">{{ 'TRANSLATE.CHOOSE.PLAN.LOADING.SUBTITLE' | translate
                }}</span>
            </div>
          </div>
          <div class="chose-plan-loading-track" aria-hidden="true">
            <span class="chose-plan-loading-bar"></span>
          </div>
        </div>
      </div>
      }
      @if (!isPlansLoading) {
      <div class="col-12">
        <p-table styleClass="choose-plan-table choose-plan-table--actions-sticky"
          [hidden]="planFordProtect?.planSelectedEnum !== warranty" [value]="excludingItemFromSellerPriceExtencion">
          <ng-template pTemplate="header">
            <tr>
              <!-- Corresponde ao radio button -->
              <th class="table"></th>

              <th class="table table-plan-name">{{ 'TRANSLATE.PLAN' | translate }}</th>
              <th class="table">{{ 'TRANSLATE.DURATION.MONTHS' | translate }}</th>
              <th class="table">{{ 'TRANSLATE.MAX.MILEAGE' | translate }}</th>
              <th class="table">{{ 'TRANSLATE.VALUE' | translate }}</th>
              @if (editExtensionAction && systemCountry === 'ARG' ) {
              <th class="table">
                {{ 'TRANSLATE.DEBIT.CONCESSIONAIRE' | translate }}
              </th>
              }
              @if (editExtensionAction && systemCountry === 'ARG' ) {
              <th class="table" colspan="2">
                {{ 'TRANSLATE.ACTIONS' | translate }}
              </th>
              }
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-rowData>
            <tr>
              @if (choosePlanDuplicatedContract.disabledExtensao === false) {
              <td class="table">
                <p-radioButton name="warranty" (click)="addExtensionWarranty(rowData)" [value]="rowData"
                  [(ngModel)]="extensionSelected"></p-radioButton>
              </td>
              }
              @if (choosePlanDuplicatedContract.disabledExtensao === true) {
              <td class="table">
              </td>
              }
              <td class="table table-plan-name"
                [title]="rowData.planName + ((rowData.policyDescription !== null && rowData.policyDescription !== '') ? ' - ' + rowData.policyDescription : '')">
                <span class="app-cell-clamp-2">{{rowData.planName}} {{(rowData.policyDescription !== null &&
                  rowData.policyDescription !== '') ? " - "+rowData.policyDescription : ''}}</span></td>
              <td class="table">{{rowData.limitTime}}</td>
              <td class="table">{{rowData.limitDistance}} km</td>

              @if (systemCountry !== 'ARG' ) {
              <td class="table">
                {{
                rowData.itemPrice
                | currency : getCurrencyCodeByCountry() : getCurrencyDisplayByCountry() : '1.2-2' : getLocaleByCountry()
                }}
              </td>
              }

              @if (systemCountry === 'ARG' ) {
              <td class="table btn-cursor" [ngClass]="{ 'table-editing-price': rowData.editing }"
                (click)="editExtension(rowData)">
                <div class="position-of-editable-items">
                  @if (!rowData.editing) {
                  <span>
                    {{
                    rowData.itemPrice
                    | currency : getCurrencyCodeByCountry() : getCurrencyDisplayByCountry() : '1.2-2' : getLocaleByCountry()
                    }}
                  </span>
                  }
                  @if (rowData.editing) {
                  <input class="input-edit" type="text"
                    [ngClass]="{ 'input-edit-invalid': isPriceOutOfBounds(rowData) }" [ngModel]="rowData.priceFormatted"
                    (ngModelChange)="formatNumber($event, rowData)" (keydown)="onPriceInputKeydown($event)"
                    (paste)="onPriceInputPaste($event, rowData)" (blur)="onPriceInputBlur(rowData)"
                    placeholder="{{ 'TRANSLATE.ENTER.PRICE' | translate }}" minlength="1" maxlength="13"
                    inputmode="decimal" autocomplete="off" pInputText>
                  }
                  @if (rowData.editing && systemCountry === 'ARG' && isBelowMinimum(rowData)) {
                  <p-message class="client-data-message" severity="error"
                    text="{{ 'TRANSLATE.INFORM.VALUE.BELOW.THE.ALLOWED' | translate }}">
                  </p-message>
                  }
                  @if (rowData.editing && systemCountry === 'ARG' && isAboveMaximum(rowData)) {
                  <p-message class="client-data-message" severity="error"
                    text="{{ 'TRANSLATE.INFORM.AMOUNT.ABOVE.THE.PERMITTED' | translate }}">
                  </p-message>
                  }
                </div>
              </td>
              }

              @if (rowData.editing && systemCountry === 'ARG' ) {
              <td class="table">
                @for (extencion of excludingDifferentToSellerExtencion; track extencion) {
                <div>
                  @if (rowData.productPolicyKey === extencion.productPolicyKey) {
                  <div>
                    {{ extencion.itemPrice | currency : getCurrencyCodeByCountry() : getCurrencyDisplayByCountry() : '1.2-2' :
                    getLocaleByCountry()
                    }}
                  </div>
                  }
                </div>
                }
              </td>
              }

              @if (rowData.editing && systemCountry === 'ARG' ) {
              <td class="table">
                <div class="icon-edit">
                  <button class="btn-cancel" (click)="cancelMaintenance(rowData)" [disabled]="rowData.isSaving">
                    <i class="pi pi-times btn-action-icon" aria-hidden="true"></i>
                    <span class="btn-cancel-span">{{ 'TRANSLATE.CANCEL' | translate }}</span>
                  </button>
                  <button class="btn-edit-save" (click)="saveMaintenance(rowData)" [disabled]="!canSaveRow(rowData)">
                    @if (rowData.isSaving) {
                    <i class="pi pi-spin pi-spinner" aria-hidden="true"></i>
                    }
                    @if (!rowData.isSaving) {
                    <i class="pi pi-check btn-action-icon" aria-hidden="true"></i>
                    }
                    <span class="btn-edit-save-span">{{ (rowData.isSaving ? 'TRANSLATE.SAVING' :
                      'TRANSLATE.SAVE') | translate }}</span>
                  </button>
                </div>
              </td>
              }

            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage" let-columns>
            <tr>
              <!-- Corresponds to the radio button -->
              <td class="table"></td>

              <td [attr.colspan]="4" class="table">
                @if (hasLoadedPlans && !isPlansLoading) {
                {{ 'TRANSLATE.NO.WARRANTY.EXTENSION' | translate }}
                }
              </td>
            </tr>
          </ng-template>
        </p-table>

        <p-table styleClass="choose-plan-table choose-plan-table--actions-sticky"
          [hidden]="planFordProtect?.planSelectedEnum !== tool" [value]="excludingItemFromSellerPriceMaintenance">
          <ng-template pTemplate="header" let-columns>
            <tr>
              <!-- Corresponde ao radio button -->
              <th class="table"></th>

              <th class="table table-plan-name">{{ 'TRANSLATE.PLAN' | translate }}</th>
              <th class="table">{{ 'TRANSLATE.REVIEWS' | translate }}</th>
              <th class="table">
                {{ (systemCountry === 'ARG' ? 'TRANSLATE.VALIDITY.MONTHS' : 'TRANSLATE.DURATION.MONTHS') | translate }}
              </th>
              <th class="table">{{ 'TRANSLATE.VALUE' | translate }}</th>
              @if (editMaintenanceAction) {
              <th class="table" colspan="2">
                {{ 'TRANSLATE.ACTIONS' | translate }}
              </th>
              }
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-rowData>
            <tr>
              @if (choosePlanDuplicatedContract.disabledManutencao === false) {
              <td class="table">
                <p-radioButton name="tools" (click)="addMaintenance(rowData)" [value]="rowData"
                  [(ngModel)]="maintenanceSelected"></p-radioButton>
              </td>
              }
              @if (choosePlanDuplicatedContract.disabledManutencao === true) {
              <td class="table">
              </td>
              }
              <td class="table table-plan-name"
                [title]="rowData.planName + ((rowData.policyDescription !== null && rowData.policyDescription !== '') ? ' - ' + rowData.policyDescription : '')">
                <span class="app-cell-clamp-2">{{rowData.planName}} {{(rowData.policyDescription !== null &&
                  rowData.policyDescription !== '') ? " - "+rowData.policyDescription : ''}}</span></td>
              <td class="table"> {{rowData.limitVisits}} </td>
              <td class="table"> {{rowData.limitTime}} </td>
              <td class="table btn-cursor" [ngClass]="{ 'table-editing-price': rowData.editing }"
                (click)="editMaintenance(rowData)">

                <div class="position-of-editable-items">

                  @if (!rowData.editing) {
                  <span>
                    {{
                    rowData.itemPrice
                    | currency : getCurrencyCodeByCountry() : getCurrencyDisplayByCountry() : '1.2-2' : getLocaleByCountry()
                    }}
                  </span>
                  }

                  @if (rowData.editing) {
                  <input class="input-edit" type="text"
                    [ngClass]="{ 'input-edit-invalid': isPriceOutOfBounds(rowData) }" [ngModel]="rowData.priceFormatted"
                    (ngModelChange)="formatNumber($event, rowData)" (keydown)="onPriceInputKeydown($event)"
                    (paste)="onPriceInputPaste($event, rowData)" (blur)="onPriceInputBlur(rowData)"
                    placeholder="{{ 'TRANSLATE.ENTER.PRICE' | translate }}" minlength="1" maxlength="13"
                    inputmode="decimal" autocomplete="off" pInputText>
                  }

                  @if (rowData.editing && systemCountry === 'BRA' && isBelowMinimum(rowData)) {
                  <p-message class="client-data-message" severity="error"
                    text="{{ 'TRANSLATE.INFORM.VALUE.CANNOT.BE.ZERO.OR.LESS' | translate }}">
                  </p-message>
                  }
                  @if (rowData.editing && systemCountry === 'BRA' && isAboveMaximum(rowData)) {
                  <p-message class="client-data-message" severity="error"
                    text="{{ 'TRANSLATE.INFORM.AMOUNT.ABOVE.THE.PERMITTED' | translate }}">
                  </p-message>
                  }
                  @if (rowData.editing && systemCountry === 'ARG' && isBelowMinimum(rowData)) {
                  <p-message class="client-data-message" severity="error"
                    text="{{ 'TRANSLATE.INFORM.VALUE.BELOW.THE.ALLOWED' | translate }}">
                  </p-message>
                  }
                  @if (rowData.editing && systemCountry === 'ARG' && isAboveMaximum(rowData)) {
                  <p-message class="client-data-message" severity="error"
                    text="{{ 'TRANSLATE.INFORM.AMOUNT.ABOVE.THE.PERMITTED' | translate }}">
                  </p-message>
                  }
                </div>
              </td>
              @if (rowData.editing) {
              <td class="table">
                <div class="icon-edit">
                  <button class="btn-cancel" (click)="cancelMaintenance(rowData)" [disabled]="rowData.isSaving">
                    <i class="pi pi-times btn-action-icon" aria-hidden="true"></i>
                    <span class="btn-cancel-span">{{ 'TRANSLATE.CANCEL' | translate }}</span>
                  </button>
                  <button class="btn-edit-save" (click)="saveMaintenance(rowData)" [disabled]="!canSaveRow(rowData)">
                    @if (rowData.isSaving) {
                    <i class="pi pi-spin pi-spinner" aria-hidden="true"></i>
                    }
                    @if (!rowData.isSaving) {
                    <i class="pi pi-check btn-action-icon" aria-hidden="true"></i>
                    }
                    <span class="btn-edit-save-span">{{ (rowData.isSaving ? 'TRANSLATE.SAVING' :
                      'TRANSLATE.SAVE') | translate }}</span>
                  </button>
                </div>
              </td>
              }

            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage" let-columns>
            <tr>
              <!-- Corresponds to the radio button -->
              <td class="table"></td>

              <td [attr.colspan]="4" class="table">
                @if (hasLoadedPlans && !isPlansLoading) {
                <span class="table-text-style">
                  {{'TRANSLATE.NO.REVISION.PLANS.AVAILABLE' | translate }}
                </span>
                }
              </td>
            </tr>
          </ng-template>
        </p-table>

        <p-table styleClass="choose-plan-table choose-plan-table--actions-sticky"
          [hidden]="planFordProtect?.planSelectedEnum !== toolPiece" [value]="excludingItemFromSellerPricePart">
          <ng-template pTemplate="header" let-columns>
            <tr>
              <!-- Corresponde ao radio button -->
              <th class="table"></th>

              <th class="table table-plan-name">{{ 'TRANSLATE.PLAN' | translate }}</th>
              <th class="table">{{ 'TRANSLATE.REVIEWS' | translate }}</th>
              <th class="table">{{ 'TRANSLATE.DURATION.MONTHS' | translate }}</th>
              <th class="table">{{ 'TRANSLATE.MAX.MILEAGE' | translate }}</th>
              <th class="table">{{ 'TRANSLATE.VALUE' | translate }}</th>
              @if (editPartAction) {
              <th class="table" colspan="2">{{ 'TRANSLATE.ACTIONS' | translate }}
              </th>
              }
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-rowData let-columns="columns">
            <tr>
              @if (choosePlanDuplicatedContract.disabledReparo === false &&
              reviewContractExists === false) {
              <td class="table">
                <p-radioButton name="toolPiece" (click)="addPart(rowData)" [value]="rowData"
                  [(ngModel)]="partSelected"></p-radioButton>
              </td>
              }
              @if (choosePlanDuplicatedContract.disabledReparo === true &&
              reviewContractExists === true) {
              <td class="table">
              </td>
              }
              <td class="table table-plan-name"
                [title]="rowData.planName + ((rowData.policyDescription !== null && rowData.policyDescription !== '') ? ' - ' + rowData.policyDescription : '')">
                <span class="app-cell-clamp-2">{{rowData.planName}} {{(rowData.policyDescription !== null &&
                  rowData.policyDescription !== '') ? " - "+rowData.policyDescription : ''}}</span></td>
              <td class="table">{{rowData.limitVisits}}</td>
              <td class="table">{{rowData.limitTime}}</td>
              <td class="table">{{rowData.limitDistance}} km</td>

              <td class="table btn-cursor" [ngClass]="{ 'table-editing-price': rowData.editing }"
                (click)="editPart(rowData)">

                <div class="position-of-editable-items">

                  @if (!rowData.editing) {
                  <span>
                    {{
                    rowData.itemPrice
                    | currency : getCurrencyCodeByCountry() : getCurrencyDisplayByCountry() : '1.2-2' : getLocaleByCountry()
                    }}
                  </span>
                  }

                  @if (rowData.editing) {
                  <input class="input-edit" type="text"
                    [ngClass]="{ 'input-edit-invalid': isPriceOutOfBounds(rowData) }" [ngModel]="rowData.priceFormatted"
                    (ngModelChange)="formatNumber($event, rowData)" (keydown)="onPriceInputKeydown($event)"
                    (paste)="onPriceInputPaste($event, rowData)" (blur)="onPriceInputBlur(rowData)"
                    placeholder="{{ 'TRANSLATE.ENTER.PRICE' | translate }}" minlength="1" maxlength="13"
                    inputmode="decimal" autocomplete="off" pInputText>
                  }

                  @if (rowData.editing && systemCountry === 'BRA' && isBelowMinimum(rowData)) {
                  <p-message class="client-data-message" severity="error"
                    text="{{ 'TRANSLATE.INFORM.VALUE.CANNOT.BE.ZERO.OR.LESS' | translate }}">
                  </p-message>
                  }
                  @if (rowData.editing && systemCountry === 'BRA' && isAboveMaximum(rowData)) {
                  <p-message class="client-data-message" severity="error"
                    text="{{ 'TRANSLATE.INFORM.AMOUNT.ABOVE.THE.PERMITTED' | translate }}">
                  </p-message>
                  }
                  @if (rowData.editing && systemCountry === 'ARG' && isBelowMinimum(rowData)) {
                  <p-message class="client-data-message" severity="error"
                    text="{{ 'TRANSLATE.INFORM.VALUE.BELOW.THE.ALLOWED' | translate }}">
                  </p-message>
                  }
                  @if (rowData.editing && systemCountry === 'ARG' && isAboveMaximum(rowData)) {
                  <p-message class="client-data-message" severity="error"
                    text="{{ 'TRANSLATE.INFORM.AMOUNT.ABOVE.THE.PERMITTED' | translate }}">
                  </p-message>
                  }
                </div>
              </td>
              @if (rowData.editing) {
              <td class="table">
                <div class="icon-edit">
                  <button class="btn-cancel" (click)="cancelMaintenance(rowData)" [disabled]="rowData.isSaving">
                    <i class="pi pi-times btn-action-icon" aria-hidden="true"></i>
                    <span class="btn-cancel-span">{{ 'TRANSLATE.CANCEL' | translate }}</span>
                  </button>
                  <button class="btn-edit-save" (click)="saveMaintenance(rowData)" [disabled]="!canSaveRow(rowData)">
                    @if (rowData.isSaving) {
                    <i class="pi pi-spin pi-spinner" aria-hidden="true"></i>
                    }
                    @if (!rowData.isSaving) {
                    <i class="pi pi-check btn-action-icon" aria-hidden="true"></i>
                    }
                    <span class="btn-edit-save-span">{{ (rowData.isSaving ? 'TRANSLATE.SAVING' :
                      'TRANSLATE.SAVE') | translate }}</span>
                  </button>
                </div>
              </td>
              }

            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage" let-columns>
            <tr>
              <!-- Corresponds to the radio button -->
              <td class="table"></td>

              <td [attr.colspan]="4" class="table">
                @if (hasLoadedPlans && !isPlansLoading) {
                {{ 'TRANSLATE.NO.WEAR.PART.PLAN' | translate }}
                }
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
      }
    </div>

    <div class="chose-plan-card chose-plan-section-box chose-plan-animate-in chose-plan-animate-delay-4">
      @if (choosePlanBuyng.part?.planName) {
      <p-card [hidden]="planFordProtect?.planSelectedEnum !== toolPiece">
        <span class="chose-plan-span-sub-total">{{ choosePlanBuyng.part?.planName }}</span><br><br>
        <div class="chose-plan-db-details" [innerHtml]="choosePlanBuyng.part?.productDetails"></div>
      </p-card>
      }

      @if (choosePlanBuyng.maintenance?.planName) {
      <p-card [hidden]="planFordProtect?.planSelectedEnum !== tool">
        <span class="chose-plan-span-sub-total">{{ choosePlanBuyng.maintenance?.planName }}</span><br><br>
        <div class="chose-plan-db-details" [innerHtml]="choosePlanBuyng.maintenance?.productDetails"></div>
      </p-card>
      }

      @if (choosePlanBuyng.extension?.planName) {
      <p-card [hidden]="planFordProtect?.planSelectedEnum !== warranty">
        <span class="chose-plan-span-sub-total">{{ choosePlanBuyng.extension?.planName }}</span><br><br>
        <div class="chose-plan-db-details" [innerHtml]="choosePlanBuyng.extension?.productDetails"></div>
      </p-card>
      }
    </div>

    <div class="chose-plan-summary chose-plan-animate-in chose-plan-animate-delay-5">

      <div class="chose-plan-total-row">
        <span class="chose-plan-total-label">{{ 'TRANSLATE.TWO.POINTS.TOTAL' | translate }}</span>
        <span class="chose-plan-total-value">{{
          calculateTotalPrice(choosePlanBuyng.extension.itemPrice, choosePlanBuyng.maintenance.itemPrice,
          choosePlanBuyng.part.itemPrice)
          | currency : getCurrencyCodeByCountry() : getCurrencyDisplayByCountry() : '1.2-2' : getLocaleByCountry()
          }}</span>
      </div>
    </div>

    <div class="col-12 md:col-12 lg:col-12 button-position chose-plan-animate-in chose-plan-animate-delay-6">

      <button id="btnReturn" class="undo-action-button return app-clean-button" type="button"
        (click)="buttonComeBack()">
        <i class="pi pi-arrow-left" aria-hidden="true"></i>
        <span class="undo-action-button-span">{{ 'TRANSLATE.RETURN' | translate }}</span>
      </button>

      <button id="btnClear" class="undo-action-button clear app-clean-button" type="button" (click)="buttonClean()"
        [disabled]="isPlansLoading">
        <i class="pi pi-trash" aria-hidden="true"></i>
        <span class="undo-action-button-span">{{ 'TRANSLATE.CLEAR.SELECTION' | translate }}</span>
      </button>

      <app-cta-button [label]="'TRANSLATE.ADVANCE'" icon="pi-arrow-right" [disabled]="selectedProduct"
        [loading]="isPlansLoading" [successState]="isCtaSuccess" (buttonClick)="buttonNext()">
      </app-cta-button>

    </div>

  </div>

</div>